// extracted by mini-css-extract-plugin
export default {"select":"SelectBatchPage_select__3M7n+"};